import { Card, CardContent, Typography, Box } from '@mui/material'

export default function ReportKpiCard({
  title,
  subtitle,
  value,
  valueTitle,
  icon = null,
  minHeight = 166,
  valueSx = {},
  titleSx = {},
  iconSx = {},
  cardSx = {},
  contentSx = {}
}) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '3px solid #E4E4E4',
        backgroundColor: '#FFFFFF',
        minHeight,
        height: '100%',
        width: '100%',
        ...cardSx
      }}
    >
      <CardContent
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          p: 2.5,
          '&:last-child': { pb: 2.5 },
          ...contentSx
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: icon ? 'auto minmax(0, 1fr)' : '1fr',
            columnGap: icon ? 1.25 : 0,
            rowGap: 1,
            alignItems: 'start',
            minWidth: 0
          }}
        >
          {icon ? (
            <Box
              sx={{
                gridColumn: 1,
                gridRow: 1,
                lineHeight: 0,
                mt: '-2px',
                flexShrink: 0,
                '& svg': {
                  display: 'block',
                  color: 'inherit'
                },
                '& .material-symbols-outlined': {
                  display: 'block',
                  color: 'inherit'
                },
                ...iconSx
              }}
            >
              {icon}
            </Box>
          ) : null}

          <Typography
            sx={{
              gridColumn: icon ? 2 : 1,
              gridRow: 1,
              fontSize: 15,
              fontWeight: 700,
              letterSpacing: 0.3,
              lineHeight: 1.25,
              color: '#111827',
              minWidth: 0,
              ...titleSx
            }}
          >
            {title}
          </Typography>

          {subtitle ? (
            <Typography
              sx={{
                gridColumn: '1 / -1',
                gridRow: 2,
                color: '#8E909B',
                fontSize: 13
              }}
            >
              {subtitle}
            </Typography>
          ) : null}
        </Box>

        <Typography
          title={valueTitle}
          sx={{
            fontSize: { xs: 28, md: 44 },
            fontWeight: 800,
            color: '#4672A3',
            lineHeight: 1.1,
            mt: 'auto',
            minWidth: 0,
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
            ...valueSx
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  )
}
